import React from "react";
import FormularioF1Turista from "../FormularioF1Turista";

interface IFormularioJ1 {
    state: any
}

export default function FormularioJ1({state}: IFormularioJ1){
    return (
        <FormularioF1Turista state={state} />
    );
}


